import React, { useEffect, useState } from 'react';
import { getStoreObj, setStoreObj } from "../../utils/storage";
import {addToCart, removeFromCart} from "../../api/cartAPI";

const ProductCard = ({ product, cart, localStoreObj, onAddToCart, onRemoveFromCart, onShowModal }) => {
    const expirationDate = product.expiration_date;

    const [isInCart, setIsInCart] = useState(
        cart.some((item) => String(item) === String(product.product_id))
    );
    const [error, setError] = useState(null);

    useEffect(() => {
        setIsInCart(cart.some((item) => String(item) === String(product.product_id)));
    }, [cart, product.product_id]);

    const handleAddToCart = async () => {
        try {
            const globalStoreObj = getStoreObj()
            console.log('ProductCard try add product to card')
            console.log('cart.length: ', cart.length, 'globalStoreObjL: ', globalStoreObj)
            console.log('globalStoreObj.storeid:', globalStoreObj?.store_id, 'product.store_id:', product.store_id)
            console.log('product:', product)
            if (cart.length === 0 || globalStoreObj?.store_id === product.store_id) {
                console.log('Adding to cart')

                await addToCart(product.product_id);
                setIsInCart(true);
                onAddToCart(product.product_id);
                setStoreObj(localStoreObj);
                console.log('ProductCard after add to cart storeObj: ', getStoreObj())
            }else {
                console.error("ERROR can't add a new product from other store")
                // Показываем модальное окно через функцию обратного вызова
                onShowModal();
            }
        } catch (error) {
            console.error('Failed to add product to cart:', error);
            setError('Помилка при додаванні товару в корзину.');
        }
    };

    const handleRemoveFromCart = async () => {
        try {
            await removeFromCart(product.product_id);
            setIsInCart(false);
            onRemoveFromCart(product.product_id);
            //setStoreObj in CatalogPage in onRemoveFromCart
        } catch (error) {
            console.error('Failed to remove product from cart:', error);
            setError('Помилка при видаленні товару з корзини.');
        }
    };

    //TODO fix product image
    const productImage = "/images/default_food_logo.svg";
    console.log('PdocutCard productImage:', productImage)
    return (
        <div className="product-card">
            <img src={productImage} alt={product.name} />
            <div className="product_card__info">
                <p id="card_original_price">{product.original_price} ₴</p>
                <p id="card_discounted_price">{product.discounted_price} ₴</p>
                <p id="card_expiration_date">Вжити до: {expirationDate}</p>
                <p id="card_title">{product.name}</p>
                {error && <p className="error-message">{error}</p>}
            </div>
            <button
                onClick={isInCart ? handleRemoveFromCart : handleAddToCart}
                id="product-card-button"
                className="primary_button">
                {isInCart ? 'Скасувати' : 'Купити'}
            </button>
        </div>
    );
};

export default ProductCard;
